/* global propel */

const fetchClosestLocation = async (lat, lng) => {
	return await fetch(
		`${propel.siteUrl}/wp-json/propel/v1/find-closest-location/`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				latitude: lat,
				longitude: lng,
			}),
		}
	);
};

const findClosestLocation = () => {
	return new Promise((resolve) => {
		if (!navigator.geolocation) {
			resolve(null);

			return;
		}

		navigator.geolocation.getCurrentPosition(
			(position) => {
				const lat = position.coords.latitude;
				const lng = position.coords.longitude;

				fetchClosestLocation(lat, lng)
					.then((response) => response.json())
					.then((data) => {
						if (
							data &&
							data.locationId &&
							data.yextId &&
							data.locationName
						) {
							resolve({
								locationId: data.locationId,
								yextId: data.yextId,
								locationName: data.locationName,
							});
						} else {
							resolve(null);
						}
					})
					.catch(() => {
						resolve(null);
					});
			},
			() => {
				resolve(null);
			},
			{
				enableHighAccuracy: true,
				timeout: 1000,
				maximumAge: 0,
			}
		);
	});
};

export default findClosestLocation;
